import { BaseEntity } from 'common-shared';

export class PrivilegeEntity extends BaseEntity {
  Name: string;
  Comment: string;
}
